import { render, staticRenderFns } from "./NewProdcuto.vue?vue&type=template&id=6de665ca&scoped=true&"
import script from "./NewProdcuto.vue?vue&type=script&lang=ts&"
export * from "./NewProdcuto.vue?vue&type=script&lang=ts&"
import style0 from "./NewProdcuto.vue?vue&type=style&index=0&id=6de665ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de665ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
